import { LuCalendarDays } from 'react-icons/lu';

import type { NavItem } from 'src/shared/components/shell/navTypes';

export const appointmentsNav: NavItem[] = [
  { icon: LuCalendarDays, label: 'Agenda', to: '/agenda', placement: 'primary' },
];
